import { SET_EB_BASVURU_OZELLIK } from "../constants/requestUrls";

import { postRequest } from "../request";

const setEbBasvuruOzellik = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
    console.log("data",data)
  return postRequest({ url: SET_EB_BASVURU_OZELLIK, data });
}

export default  setEbBasvuruOzellik ;